import {
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { map, times } from 'lodash';
import React from 'react';
import { Modal } from '../../../components';
import { useDispatch, useSelector, configurationSlice } from '../../../stores';
import { theme } from '../../../theme';
import { handleMoney } from '../../../utils/Helpers';
import useScreenSize from '../../../utils/useScreenSize';

export const ConfigurationInfoModal: React.FC = () => {
  const dispatch = useDispatch();
  const {
    configurationInfo,
    configurationInfoIsOpen,
    configurationInfoLoading,
  } = useSelector((state) => state.configurationReducer);
  const screenSize = useScreenSize();

  const handleClose = () => {
    dispatch(configurationSlice.actions.toggleConfigurationInfoIsOpen());
  };

  const handleWeekDays = (weekDays: string[]) => {
    if (!weekDays || !Array.isArray(weekDays) || weekDays.length === 0)
      return '';
    let handledDays = '';
    map(weekDays, (day) => {
      switch (day) {
        case '1':
          handledDays += 'Seg ';
          break;
        case '2':
          handledDays += 'Ter ';
          break;
        case '3':
          handledDays += 'Qua ';
          break;
        case '4':
          handledDays += 'Qui ';
          break;
        case '5':
          handledDays += 'Sex ';
          break;
        case '6':
          handledDays += 'Sab ';
          break;
        default:
          handledDays += 'Dom ';
          break;
      }
    });
    return handledDays;
  };

  return (
    <Modal
      open={configurationInfoIsOpen}
      onClose={handleClose}
      title='Detalhamento'
      width={screenSize <= 600 ? screenSize - 20 : 600}
    >
      <>
        {configurationInfoLoading ? (
          <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            {times(10, () => (
              <Skeleton animation='wave' height={29} width='100%' />
            ))}
          </TableContainer>
        ) : (
          <>
            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
              <Table
                sx={{ minWidth: 500 }}
                size='small'
                aria-label='a dense table'
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      align='left'
                      sx={{
                        borderBottom: 0.1,
                        borderColor: theme.palette.divider,
                      }}
                      colSpan={3}
                    >
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '18px', fontWeight: 'bold' }}
                      >
                        {configurationInfo?.name}
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '14px', fontWeight: 'bold' }}
                      >
                        Dias da semana
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ minWidth: '120px' }}>
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '14px', fontWeight: 'bold' }}
                      >
                        Horário Inicial
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ minWidth: '120px' }}>
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '14px', fontWeight: 'bold' }}
                      >
                        Horário Final
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {map(configurationInfo?.operationPeriods, (item) => {
                    return (
                      <TableRow
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: theme.palette.action.hover,
                          },
                          '&:last-child td, &:last-child th': {
                            borderBottom: 0.1,
                            borderColor: theme.palette.divider,
                          },
                        }}
                      >
                        <TableCell component='th' scope='row'>
                          {handleWeekDays(item.weekDays)}
                        </TableCell>
                        <TableCell component='th' scope='row'>
                          {item.startTime}
                        </TableCell>
                        <TableCell component='th' scope='row'>
                          {item.endTime}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '14px', fontWeight: 'bold' }}
                      >
                        Categoria
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '14px', fontWeight: 'bold' }}
                      >
                        Período/Fração
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color='primary.main'
                        sx={{ fontSize: '14px', fontWeight: 'bold' }}
                      >
                        Preço
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {map(configurationInfo?.prices, (item) => {
                    return (
                      <TableRow
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: theme.palette.action.hover,
                          },
                          // hide last border
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell component='th' scope='row'>
                          {item.vehicleCategory}
                        </TableCell>
                        <TableCell component='th' scope='row'>
                          {item.timePeriod}
                        </TableCell>
                        <TableCell component='th' scope='row'>
                          {handleMoney(parseFloat(item.price))}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
      </>
    </Modal>
  );
};
